import { useState, useEffect, useCallback } from 'react';
import Display from '../Display';
import Chat from '../Chat';
import ChatInput from '../ChatInput';
import { useChatbotStore, useChatStateStore, useMessagesStore, useProductsStore, useUserStore, useUtmStore, useToastStore } from '../../zustand/store';
import { useChatbot, useHistoryUpdate, useLoadHistory, useSendPDPMessage, useSendMessageWithWebSocket } from '../../services/queries/chatbotQueries';
import { setColorCode } from '../../utils/utils';
import { useParams, useSearchParams } from 'react-router-dom';
import { sendInputFocusStatus } from '../../utils/utils';
import { handleConsoleTourMessage } from '../../utils/consoleTourHandler';


import { useAgentSocketStore } from '../../zustand/agentSocketStore';

const ChatFieldBase = (props) => {
    const { chatbot, setBootConfigGreetingComment } = useChatbotStore();
    const { products } = useProductsStore();
    const { isStreaming, isPreAnswered, setIsConsole, isConsole, displayLocation, setDisplayLocation, setDisplayItemId, setIsNewProduct, setIsChatbotPending, setEnableMode, setIsChatOpen, setIsStreaming, setCurrentPage, currentPage, setIsInConsoleTour } = useChatStateStore();
    const { setUtmParams } = useUtmStore();
    const { partnerType, chatUserId, partnerId,setPartnerId, setChatUserId, setIsMobileDevice, setPartnerType } = useUserStore();
    const { setCustomizedGreeting } = useChatStateStore(); // 🧪 맞춤형 그리팅 설정 함수
    const { setToastMessage, setIsToastVisible } = useToastStore();
    const { refetch: refetchLoadHistory } = useLoadHistory();
    const [mode, setMode] = useState('gentooGreeting');
    const [isDisplayVisible, setIsDisplayVisible] = useState(false);
    const queryString = window.location.search;
    const [searchParams, setSearchParams] = new useSearchParams(queryString);
    const chatBotId = useParams().chatBotId;
    const lyclePartnerId = searchParams.get('ptid');
    const { refetch: refetchChatbot } = useChatbot(lyclePartnerId);
    const { mutate: sendPDPMessage } = useSendPDPMessage();
    const { mutateAsync: updateHistory } = useHistoryUpdate();
    const { messages, streamMessage, setGuidelineContent, setGuidelineTitle, setGuidelineId } = useMessagesStore();
    const [visitedState, setVisitedState] = useState(null);
    const { mutate: sendMessageWithWebSocket } = useSendMessageWithWebSocket();

    useEffect(() => {
        if (isConsole) return;
        if (chatBotId === '49' || chatBotId === '153') {
            const lycleChatUserId = searchParams.get('cuid') || Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            const lycleIsMobileDevice = searchParams.get('ch');
            const lycleDisplayLocation = searchParams.get('dp');
            const lycleDisplayItemId = searchParams.get('it');
            const lycleIsConsole = searchParams.get('isConsole') === 'true';
            const lycleUtm = {
                utms: searchParams.get('utms'),
                utmm: searchParams.get('utmm'),
                utmca: searchParams.get('utmca'),
                utmco: searchParams.get('utmco'),
                utmt: searchParams.get('utmt'),
                tp: searchParams.get('tp'),
            }
            setPartnerId(lyclePartnerId);
            setPartnerType('gentoo');
            setChatUserId(lycleChatUserId);
            setIsMobileDevice(lycleIsMobileDevice);
            setDisplayLocation(lycleDisplayLocation);
            setDisplayItemId(lycleDisplayItemId);
            setIsConsole(lycleIsConsole);
            setUtmParams(lycleUtm);
        }

    }, [])

    const handleConsoleTourMessageWrapper = (e) => {
        const { clearExamples } = useProductsStore.getState();
        handleConsoleTourMessage(e, {
            setIsStreaming,
            setIsChatbotPending,
            sendInputFocusStatus,
            currentPage,
            setIsInConsoleTour,
            clearExamples,
            sendMessageWithWebSocket
        });
    };

    useEffect(() => {
        window.addEventListener('message', handleConsoleTourMessageWrapper);
        return () => {
            window.removeEventListener('message', handleConsoleTourMessageWrapper);
        };
    }, []);

    const handleMessage = useCallback((e) => {
        const { 
            currentPage, 
            buttonClickState, 
            clickedElement, 
            enableMode, 
            addedProductToCart, 
            customizedGreeting,
            bootConfigGreetingComment, 
        } = e.data;
        const currentEnableMode = useChatStateStore.getState().enableMode;
        if (currentEnableMode !== enableMode) {
            setEnableMode(enableMode);
        }

        if (customizedGreeting) {
            setCustomizedGreeting(customizedGreeting);
        }

        if (bootConfigGreetingComment) {
            setBootConfigGreetingComment(bootConfigGreetingComment);
        }

        // carouselRedirect 이벤트 처리
        // if (clickedElement === 'carouselRedirect') {
        //     updateHistory({ url: currentPage, itemId: '' })
        //         .then((visitedState) => {
        //             setVisitedState(visitedState);
        //             if (displayLocation === 'PRODUCT_DETAIL' && visitedState) {
        //                 if (visitedState === 'FIRST_VISIT') {
        //                     setIsChatbotPending(true);
        //                     sendPDPMessage({ chatType: 'default' });
        //                 } else if (visitedState === 'REVISIT') {
        //                     setIsChatbotPending(true);
        //                     sendPDPMessage({ chatType: 'revisit' });
        //                 }
        //             }
        //         });
        // }

        // 플로팅 버튼 클릭
        if ((buttonClickState && clickedElement === 'floatingContainer') || clickedElement === 'carouselRedirect') {
            updateHistory({ url: currentPage, itemId: '' })
                .then((visitedState) => {
                    setVisitedState(visitedState);
                    if (displayLocation === 'PRODUCT_DETAIL' && visitedState) {
                        if (visitedState === 'FIRST_VISIT') {
                            setIsChatbotPending(true);
                            sendPDPMessage({ chatType: 'default' });
                        } else if (visitedState === 'REVISIT') {
                            setIsChatbotPending(true);
                            sendPDPMessage({ chatType: 'revisit' });
                        }
                    }
                });
            setIsChatOpen(true);
        }

        // 닫기 버튼 클릭
        if (buttonClickState && (clickedElement === 'closeButtonContainer' || clickedElement === 'closeActionArea')) {
            setIsNewProduct(false);
            setIsChatOpen(false);
        }

        // 장바구니 상품 담기 성공
        if (addedProductToCart) {
            setToastMessage('장바구니에 상품을 담았어요');
            setIsToastVisible(true);
        }

    }, [displayLocation]);

    useEffect(() => {
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        }
    }, [handleMessage])

    // Ensure chatInput is functional, but note that streaming chat is currently non-operational
    useEffect(() => {
        setIsStreaming(false);
        setIsChatbotPending(false);
    }, []);

    useEffect(() => {
        if (partnerType === 'fastfive' && !isPreAnswered) {
            setIsDisplayVisible(false);
        } else if (messages.length === 0 && streamMessage.length === 0) {
            setIsDisplayVisible(false);
        } else {
            setIsDisplayVisible(true);
        }
    }, [messages, streamMessage, isPreAnswered]);

    useEffect(() => {
        refetchLoadHistory();
        setColorCode(chatbot?.colorCode);
        setIsMobileDevice(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    }, [chatbot]);

    useEffect(() => {
        if (products.length > 0) {
            if (partnerType === 'fastfive') {
                setMode('productVerticalList');
            } else {
                setMode(chatbot?.carouselType === 'single' ? 'productSingle' : (chatbot?.carouselType === 'carousel-horizontal' ? 'productHorizontalList' : 'productVerticalList') || 'productSingle');
            }
        } else {
            setMode('gentooGreeting');
        }
    }, [products]);
    
    useEffect(() => {
        const handler = (event) => {
            if (event.data.type === 'guidelineUpdate') {
                setGuidelineId(event.data.id);
                setGuidelineContent(event.data.content);
                setGuidelineTitle(event.data.title);
            }
        };

        window.addEventListener('message', handler);
        return () => {
            window.removeEventListener('message', handler);
        };
    }, []);

    const connect = useAgentSocketStore((s) => s.connect);
    
    useEffect(() => {
        connect({
            action: "register",
            chatUserId: chatUserId,
            // chatUserId: 'tTrifHIpxtzgs6HK3w8NeLa22VSU443c',
            externalKey: partnerId
        }, displayLocation);
    }, [connect,chatUserId, partnerId]);

    return (
        <div style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <Chat />
            {
                isDisplayVisible &&
                <Display mode={mode} />
            }
            {
                Object.keys(chatbot.preQuestion.questions).length === 0 || isPreAnswered ?
                    <ChatInput /> :
                    <div style={{ width: '100%', height: '86px' }}>
                    </div>
            }
        </div>
    );
};

export default ChatFieldBase